export const getSectionTips = (sectionKey, object) => {
  const tips = object[sectionKey].tips;

  return tips;
};

export const getTipInstructions = (instructions_arr) => {
  let instructions = '';

  instructions_arr.forEach((instruction) => {
    instructions = `${instructions} ${instruction}`;
  });

  return instructions;
};

export const mapTips = (tips) => {
  let mappedTips = [];

  tips.map((tip) => {
    return mappedTips.push({
      headingText: tip.name.toUpperCase(),
      image: tip.image_url,
      paragraphText: getTipInstructions(tip.instructions),
    });
  });

  return mappedTips;
};
